export enum WindowSpecType {
  UNKNOWN = 'unknown',
  YEAR_OF_CHANGE = 'year-of-change',
  WINDOW_TYPE = 'window-type',
  U_VALUE = 'u-value'
}
